interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-lg border border-dashed border-background-300 bg-background-50">
      <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-2xl mb-4">
        <i className={icon}></i>
      </span>
      <h3 className="text-base font-medium text-foreground-900 mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-foreground-500 max-w-md leading-relaxed">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm whitespace-nowrap transition-colors cursor-pointer"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}